import * as Sentry from '@sentry/nuxt'
import Clarity from '@microsoft/clarity'

import { pick } from '@shared/lib/collections'
import { getAmplitudeLink, getClarityUrl } from '@shared/lib/amplitude'

import { useCustomerStore } from './customer-store/store'

export const initClarity = (): void => {
  const runtimeConfig = useRuntimeConfig().public
  const environment = runtimeConfig.environment || null
  const brand = runtimeConfig.brand

  const customerStore = useCustomerStore()

  const projectId = 'uja2hxxs69'

  const customer = customerStore.customer || null

  if (customer) {
    const id = customer?.id || null
    const deviceId = customer?.device_id || null
    const firstName = customer?.first_name || null
    const lastName = customer?.last_name || null

    const amplitudeUrl = getAmplitudeLink(deviceId)
    const clarityUrl = getClarityUrl(projectId)

    const ready = customerStore.isClarityReady

    if (!ready) {
      if (projectId && deviceId) {
        Clarity.init(projectId)
        Clarity.identify(deviceId)
        Clarity.setTag('brand', brand)

        customerStore.setClarityReady(true)

        const customerInfo = pick({
          customer_id: id,
          device_id: deviceId,
          first_name: (firstName || '---'),
          last_name: (lastName || '---'),
          amplitude_url: amplitudeUrl,
          environment,
        })

        const customerClarityInfo = pick({
          ...customerInfo,
        })

        Object.entries(customerClarityInfo).forEach(item => {
          const key = item[0] as string
          const value = item[1] as string
          Clarity.setTag(key, value)
        })

        Sentry.setContext('Customer info', {
          ...customerInfo,
          clarity_url: clarityUrl,
        })
      }
    }
  }
}
